import { h } from "preact";

const CredentialSkills = ({ skills, className }) => {
  if (!skills || skills.length === 0) return null;

  const skillsList = typeof skills === "string" ? skills.split(";") : skills;

  return (
    <article class={className}>
      <p class="text-lg py-2">HABILIDADES ADQUIRIDAS</p>
      <div class="w-full rounded-lg bg-[#FFF] p-5 my-3 flex flex-wrap gap-3">
        {skillsList.map((skill) => (
          <span class="p-2 rounded-[10px] bg-[#d9d9d9] text-sm">
            {skill.trim()}
          </span>
        ))}
      </div>
    </article>
  );
};

export default CredentialSkills;
